// extracted by css-extract-rspack-plugin
export default {"titleBarHeight":"80px","mobileToolbarHeight":"53px"};